import {ButtonDefault, LangSwitchBtn} from "./components/buttons/buttons";
import {LinkStyled} from "./components/text/text";
import {
    BodyContainer,
    ButtonsAndHeadersContainer,
    ButtonsMainContainer,
    FooterContainer,
    FooterLine,
    GirlImage,
    HeadersContainer,
    HomepageMainContainer,
    LogoAndLangContainer,
    LogoContainer,
    LogoRC,
    QRContainer,
    QrImage,
    SwitchLanguage,
    SocialIconsContainer
} from "./components/containers/containers";
import {H1Styled, H2Styled} from "./components/headers/headers";
import GlobalStyle from "./styles/globals";
import {useState} from "react";
import logo_rus from "./static/RC-logo-rus.svg"
import girl from "./static/girl.svg";
import qr from "./static/QR.svg";
import CookieModal from "./components/cookie-modal/CookieModal";
import {IconSocial, LinkSocial, LogoIconContainer} from "./components/icon/icon";
import max from "./static/max-icon.svg"
import vk from "./static/vk-icon.svg"
import telegram from "./static/telegram-icon.svg"


function App() {
    document.title = 'Потенциал Страны'
    const [switchLang, setSwitchLang] = useState('ru')
    if (switchLang === 'ru') {
        return (<HomepageMainContainer>
                <GlobalStyle/>
                <CookieModal lang={switchLang}/>
                <LogoAndLangContainer>
                    <LogoContainer>
                        <LogoRC src={logo_rus} alt='лого'/>
                    </LogoContainer>
                    <SwitchLanguage>
                        <LogoIconContainer>
                            <LinkSocial href="https://max.ru/id7706412930_11_bot" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={max}/>
                            </LinkSocial>
                            <LinkSocial href="https://vk.com/country_potential" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={vk}/>
                            </LinkSocial>
                            <LinkSocial href="https://t.me/Country_Potential" target="_blank" rel="noopener noreferrer">
                                <IconSocial src={telegram}/>
                            </LinkSocial>
                        </LogoIconContainer>
                        <LangSwitchBtn onClick={() => setSwitchLang('eng')}>{switchLang === "ru" ? "eng" : "ru"}</LangSwitchBtn>
                    </SwitchLanguage>
                </LogoAndLangContainer>
                <BodyContainer>
                    <ButtonsAndHeadersContainer>
                        <HeadersContainer>
                            <H1Styled>ПОТЕНЦИАЛ СТРАНЫ</H1Styled>
                            <H2Styled>Пространство карьерных возможностей, объединяющее<br/> работодателей и начинающих специалистов</H2Styled>
                        </HeadersContainer>
                        <ButtonsMainContainer>

                            <ButtonDefault onClick={() => {
                                window.ym(98731152, 'reachGoal', 'projectsClick')
                                console.log('click')
                            }} href="https://projects.roscongress.org"> Проекты
                                Экосистемы</ButtonDefault>

                            <ButtonDefault onClick={() => {
                                window.ym(98731152, 'reachGoal', 'botClick')
                                console.log('click')
                            }} href="/chatbot/">Чат-бот</ButtonDefault>
                        </ButtonsMainContainer>
                        <SocialIconsContainer>
                            <LinkSocial href="https://max.ru/id7706412930_11_bot" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={max}/>
                            </LinkSocial>
                            <LinkSocial href="https://vk.com/country_potential" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={vk}/>
                            </LinkSocial>
                            <LinkSocial href="https://t.me/Country_Potential" target="_blank" rel="noopener noreferrer">
                                <IconSocial src={telegram}/>
                            </LinkSocial>
                        </SocialIconsContainer>
                    </ButtonsAndHeadersContainer>
                    <QRContainer>
                        <GirlImage src={girl} alt='девочка'/>
                        <QrImage src={qr} alt='qr'/>
                    </QRContainer>
                </BodyContainer>
                <FooterContainer>
                    <FooterLine>© Фонд «Росконгресс», 2026</FooterLine>
                    <FooterLine>123610, г. Москва,</FooterLine>
                    <FooterLine>Наб. Краснопресненская, д. 12, п. 7, пом. 1101</FooterLine>
                    <FooterLine>
                        Данный сайт использует файлы данных о посещениях в соответствии с{' '}
                        <LinkStyled
                            href="https://roscongress.content.rcmedia.ru/upload/iblock/8d5/nnql3rgh6an3ynxgperp3tosr7j4pxgl/Politika_obrabotki_PDn.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Политикой обработки персональных данных
                        </LinkStyled>
                        <br/>
                        в Фонде «Росконгресс» и{' '}
                        <LinkStyled
                            href="https://roscongress.content.rcmedia.ru/upload/iblock/773/kg487b73e3i9my81xrf59l3n2fgc6qf8/Pravila_obrabotki_dannykh_dlya_vedeniya_statistiki.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Правилами обработки данных для ведения статистики
                        </LinkStyled>
                        .
                        <br/>
                        Продолжая пользоваться сайтом, Вы соглашаетесь на сбор и использование нами таких данных.
                    </FooterLine>
                </FooterContainer>
            </HomepageMainContainer>);
    } else {
        return (<HomepageMainContainer>
                <GlobalStyle/>
                <CookieModal/>
                <LogoAndLangContainer>
                    <LogoContainer>
                        <LogoRC src={logo_rus} alt='лого'/>
                    </LogoContainer>
                    <SwitchLanguage>
                        <LogoIconContainer>
                            <LinkSocial href="https://max.ru/id7706412930_11_bot" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={max}/>
                            </LinkSocial>
                            <LinkSocial href="https://vk.com/country_potential" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={vk}/>
                            </LinkSocial>
                            <LinkSocial href="https://t.me/Country_Potential" target="_blank" rel="noopener noreferrer">
                                <IconSocial src={telegram}/>
                            </LinkSocial>
                        </LogoIconContainer>
                        <LangSwitchBtn onClick={() => setSwitchLang('ru')}>{switchLang === "eng" ? "ru" : "eng"}</LangSwitchBtn>
                    </SwitchLanguage>
                </LogoAndLangContainer>
                <BodyContainer>
                    <ButtonsAndHeadersContainer>
                        <HeadersContainer>
                            <H1Styled>THE COUNTRY’S HUMAN POTENTIAL</H1Styled>
                            <H2Styled>Space of career opportunities uniting employers and aspiring specialists</H2Styled>
                        </HeadersContainer>
                        <ButtonsMainContainer>

                            <ButtonDefault onClick={() => {
                                window.ym(98731152, 'reachGoal', 'projectsClick')
                                console.log('click')
                            }} href="https://projects.roscongress.org/stendinitsiativfondaroskongress_aukf/">ECOSYSTEM
                                PROJECTS</ButtonDefault>

                            <ButtonDefault onClick={() => {
                                window.ym(98731152, 'reachGoal', 'botClick')
                                console.log('click')
                            }} href="/chatbot/">CHAT BOT</ButtonDefault>
                        </ButtonsMainContainer>
                        <SocialIconsContainer>
                            <LinkSocial href="https://max.ru/id7706412930_11_bot" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={max}/>
                            </LinkSocial>
                            <LinkSocial href="https://vk.com/country_potential" target="_blank"
                                        rel="noopener noreferrer">
                                <IconSocial src={vk}/>
                            </LinkSocial>
                            <LinkSocial href="https://t.me/Country_Potential" target="_blank" rel="noopener noreferrer">
                                <IconSocial src={telegram}/>
                            </LinkSocial>
                        </SocialIconsContainer>
                    </ButtonsAndHeadersContainer>
                    <QRContainer>
                        <GirlImage src={girl} alt='девочка'/>
                        <QrImage src={qr} alt='qr'/>
                    </QRContainer>
                </BodyContainer>
                <FooterContainer>
                    <FooterLine>© Фонд «Росконгресс», 2026</FooterLine>
                    <FooterLine>123610, г. Москва,</FooterLine>
                    <FooterLine>Наб. Краснопресненская, д. 12, п. 7, пом. 1101</FooterLine>
                    <FooterLine>
                        Данный сайт использует файлы данных о посещениях в соответствии с{' '}
                        <LinkStyled
                            href="https://roscongress.content.rcmedia.ru/upload/iblock/8d5/nnql3rgh6an3ynxgperp3tosr7j4pxgl/Politika_obrabotki_PDn.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Политикой обработки персональных данных
                        </LinkStyled>
                        <br/>
                        в Фонде «Росконгресс» и{' '}
                        <LinkStyled
                            href="https://roscongress.content.rcmedia.ru/upload/iblock/773/kg487b73e3i9my81xrf59l3n2fgc6qf8/Pravila_obrabotki_dannykh_dlya_vedeniya_statistiki.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Правилами обработки данных для ведения статистики
                        </LinkStyled>
                        .
                        <br/>
                        Продолжая пользоваться сайтом, Вы соглашаетесь на сбор и использование нами таких данных.
                    </FooterLine>
                </FooterContainer>
            </HomepageMainContainer>)
    }
}

export default App;